'use strict';
import isDate from 'lodash/isDate';
import isFunction from 'lodash/isFunction';
import memoize from 'lodash/memoize';
import moment from 'moment/moment';
import React, {Component} from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {ListItem} from '../../../components/lists/ListItem';
import {Button} from '../../../components/buttons/Button';


export class TodoMessageItemView extends Component {
  static propTypes = {
    className: T.string,
    model: T.object,
    isOwnFeed: T.bool,
    onClick: T.func,
  };

  static formatDate = memoize(date => moment(date).format('lll'), date => isDate(date) ? date.getTime() : date);

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleClickAction = this.handleClickAction.bind(this);
    this.renderAction = this.renderAction.bind(this);
  }

  handleClick(e) {
    if (isFunction(this.props.onClick)) {
      this.props.onClick(e, this.props.model);
    }
  }

  handleClickAction(e, actionId) {
    if (isFunction(this.props.onClickAction)) {
      this.props.onClickAction(e, this.props.model, actionId);
    }
  }

  render() {
    const props = this.props;
    const ItemTag = props.isOwnFeed ? 'div' : ListItem;
    return (
      <ItemTag
        className={classNames("TodoMessageItem", props.className)}
        onClick={this.handleClick}
      >
        <div className="TodoMessageItem__card">
          <div className="TodoMessageItem__body">
            <i className={`icon ${props.model.type}`} />
            <div>
              <div className={"TodoMessageItem__badge " + props.model.tagName}>
                {props.model.tagName}
              </div>
              <div className="TodoMessageItem__message selectable">
                {props.model.message}
              </div>
            </div>
            <div className="TodoMessageItem__date">
              {TodoMessageItemView.formatDate(props.model.date)}
            </div>
          </div>

          {this.props.model.selectedAction ? null : (
            <div className="TodoMessageItem__actions">
              {Object.values(props.model.actions).map(this.renderAction)}
            </div>
          )}
        </div>
      </ItemTag>
    );
  }

  renderAction(action) {
    return (
      <Button
        key={action.id}
        className={classNames(`TodoMessageItem__action TodoMessageItem__action_${action.type}`, {
          active: this.props.model.selectedAction === action.id,
        })}
        useClickBlock={true}
        label={action.message}
        bindParam={action.id}
        onClick={this.handleClickAction}
      />
    );
  }
}

TodoMessageItemView.propTypes = {
  className: T.string,
};

TodoMessageItemView.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./src/js/todo-messages/components/TodoMessageItem/TodoMessageItemView.js